import { gql } from "lib/apolloClient";

export const gradeFragment = {
  basicGradeDetails: gql`
    fragment gradeItem on Grade {
      id
      name
      globalGrade {
        id
        uid
        name
        constants
      }
    }
  `,
};

export const curriculumProgramFragment = {
  curriculumProgramBasicDetails: gql`
    fragment curriculumProgramBasicDetailsItem on CurriculumProgram {
      id
      type
      label
      acronym
    }
  `,
};

export const unitPlanFragment = {
  unitPlanDetails: gql`
    fragment unitPlanItem on UnitPlan {
      id
      title {
        id
        value
      }
      unitType {
        id
        value
      }
      image {
        id
        value
      }
      templateId
      curriculumProgram {
        ...curriculumProgramBasicDetailsItem
      }
      unitFlowFeed @include(if: $getUnitFlowId) {
        unitFlowId
      }
      subjects {
        id
        value
        resolvedMinimalTree {
          ... on ResolvedFieldSubjectSet {
            id
            subjects {
              id
              name
              isArchived
            }
          }
        }
      }
      courses {
        id
        academicYears {
          id
          isCurrentAcademicYear
        }
      }
    }
    ${curriculumProgramFragment.curriculumProgramBasicDetails}
  `,
};
